import React from 'react';
import '../styles/forceModal.css';

function CreativeWorkScoreModal({ score, onClose }) {
  return (
    <div className="force-modal-overlay" onClick={onClose}>
      <div className="force-modal-content" onClick={(e) => e.stopPropagation()}>
        {/* Close Button */}
        <button className="force-modal-close" onClick={onClose}>
          ✕
        </button>

        {/* Header */}
        <div className="force-modal-header" style={{ textAlign: 'center' }}>
          <h2 style={{ marginBottom: '0.5rem' }}>Creative Work Score</h2>
          <p style={{ fontSize: '2rem', fontWeight: 'bold', color: '#0066a1', margin: '0.5rem 0 0 0' }}>{score} / 100</p>
        </div>

        {/* Content */}
        <div className="force-modal-body">
          <h3 style={{ fontSize: '1.1rem', fontWeight: '600', color: '#333', marginBottom: '1rem' }}>Scoring</h3>
          
          <div style={{ marginBottom: '1rem' }}>
            <p style={{ fontSize: '1rem', fontWeight: '600', color: '#333', marginBottom: '0.5rem' }}>
              • Above 75: You have healthy creative work habits.
            </p>
            <p style={{ fontSize: '0.95rem', color: '#666', lineHeight: '1.6', marginLeft: '1.5rem', marginBottom: '1rem' }}>
              Focus on keeping a balanced distribution across all Wheel of Work components.
            </p>
          </div>

          <div>
            <p style={{ fontSize: '1rem', fontWeight: '600', color: '#333', marginBottom: '0.5rem' }}>
              • Below 75: You have opportunities to strengthen how you capture, share, decide, act, and follow through.
            </p>
          </div>
        </div>

        {/* Close Button (Mobile friendly footer) */}
        <div className="force-modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}

export default CreativeWorkScoreModal;
